// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// routes
import { paths } from 'src/routes/paths';
// locales
// components
import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

export default function NavUpgrade() {
  const { user } = useMockedUser();

  const simpleUser = user?.userType === "user" && paths.dashboard.user.profile;
  const organizer = user?.userType === "organizer" && paths.orangizerDashboard.user.profile;
  const superAdmin = user?.userType === "super-admin" && paths.superAdminDashboard.user.account;


  return (
    <Stack
      sx={{
        px: 2,
        py: 5,
        textAlign: 'center',
      }}


    >
      <Stack alignItems="center">
        <Box sx={{ position: 'relative' }} component={RouterLink} to={simpleUser || organizer || superAdmin} >
          <Avatar src={user?.profileIcon} alt={user?.displayName} sx={{ width: 48, height: 48 }} />
        </Box>

        <Stack spacing={0.5} sx={{ mt: 1.5, mb: 2 }}>
          <Typography variant="subtitle2" noWrap component={RouterLink}
            to={simpleUser || organizer || superAdmin}
            sx={{ textDecoration: 'none', color: 'text.primary' }}>
            {user?.displayName}
          </Typography>

          <Typography variant="body2" noWrap component={RouterLink}
            to={simpleUser || organizer || superAdmin}
            sx={{ textDecoration: 'none', color: 'text.disabled' }}>
            {user?.email}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
